<template>
    <div class="post rating-facebook" :class="{'response-comment' : responseComment}">
        <div class="detail-event-header">
            <AvatarComponent :typeNetwork="page.network" :urlPicture="page.avatar"></AvatarComponent>
            
            <div class="info">
                <div class="namePage">
                 {{page.name}}
                </div>
                <div class="typeEvent">
                    <p html>{{ dateFormatPost(event.date*1000) }}</p>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
        </div>
        <div class="scrollable">
          
            <div v-if="!isLoading" class="container-content-comments">
                <div class="container-comment">
                        
                        <div class="comment" :class="{'has-response' : false, 'hidden':false}">
                        
                            <div class="picture-user">
                                <img :src="event.user && event.user.picture && event.user.picture.data ? event.user.picture.data.url : ''">
                                <div class="lineStart"></div>
                                
                            </div>
                            <div class="container-content">
                                <div class="content">
                                    <p class="name-user">{{ event.data.changes.value.reviewer_name }}</p>
                                    <p class="text">
                                        <template v-if="event.data.changes.value.recommendation_type">
                                            <span class="ratting-type">Avis {{ $t('dash.inbox.rating.recommendation_type.' + event.data.changes.value.recommendation_type.toLowerCase()) }} : </span>
                                        </template>
                                        
                                        {{ event.data.changes.value.review_text }}
                                    </p>
                           
                                </div>
                                <div class="info-content">
                                    <div class="date">{{ dateFormat(event.data.changes.value.created_time) }}</div>
                                    <div class="action">
                                        <div class="answer" @click="startResponseComment(event.data.changes.value.reviewer_id)">Répondre</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                     
                    </div>
            </div>
            <div v-else class="container-content-comments loading-content">
                <div class="container-comment">       
                    <div class="comment">
                        <div class="picture-user">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC">             
                            <div class="lineStart"></div>         
                        </div>
                        <div class="container-content">
                            <div class="content">
                                <p class="name-user">www</p>
                                <p class="text">{{ 'w'.repeat(15+Math.random()*15) }}</p>
                        
                            </div>
                            <div class="info-content">
                                <!-- <div class="date"></div> -->
                                <div class="action">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormSendMessage v-on:onSubmitMessage="sendComment" :activeMedia="false" ></FormSendMessage>
        <div class="container-response-comment" v-if="responseComment">
            <p>Répondre à <span>{{event.data.changes.value.reviewer_name}}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopResponseComment"></i>
        </div>
    </div>
</template>

<script>
    import mixinModeration from './../../mixins/Moderation.vue'
    import ContextMenu from './../contextMenu/contextMenuInit.vue'
    import FormSendMessage from './FormSendMessage'
    import AvatarComponent from './../utils/avatar.vue'
    import SelectComponent from './../utils/select.vue'


    export default {
        name: 'component-facebook-rating',

        components: {
            FormSendMessage,
            ContextMenu,
            AvatarComponent,
            SelectComponent,
        },

        mixins: [mixinModeration],

        props: {
            page: Object,
            event: Object,
            isLoading : {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                responseComment: false
            }
        },

        mounted () {
            //this.getDetailAllComment()

            
        },

        methods: {
            changeStatus(status){
                this.$emit('changeStatus', status)
            },

            getFormatNumber(number) {
                const absNumber = Math.abs(number);
                const fixed = function(value){
                    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
                }

                if (absNumber >= 1e9) {
                    return fixed(number / 1e9) + ' MD';
                } else if (absNumber >= 1e6) {
                    return fixed(number / 1e6) + ' M';
                } else if (absNumber >= 1e3) {
                    return fixed(number / 1e3) + ' K';
                } else {
                    return number.toString();
                }
                
            },

            dateFormat(dateComment) {
                if (typeof dateComment !== "object") {
                    dateComment = new Date(dateComment)
                }

                let date = new Date()
                const diffInMilliseconds = Math.abs(date - dateComment);
                const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
                const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
                const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
                const diffInWeeks = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 7));
                const diffInYears = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 365));

                if (diffInYears > 0) {
                    return diffInYears + (diffInYears === 1 ? ' an' : ' ans');
                } else if (diffInWeeks > 0) {
                    return diffInWeeks + 'sem';
                } else if (diffInDays > 0) {
                    return diffInDays + 'j';
                } else if (diffInHours > 0) {
                    return diffInHours + 'h';
                } else {
                    return diffInMinutes + 'min';
                }
            },

            dateFormatPost(dateMessage) {
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            have_liked_comment(nodeId){

                try {
                    this.post.comment.likes.data.find(liker => liker.id == this.page.network_id) 
                } catch (error) {
                    return false
                }
         
            
            },

            startResponseComment(commentId) {
                this.responseComment = commentId
            },

            stopResponseComment() {
                this.responseComment = false
            },

            getCommentById(commentId,returnNode = false) {
                if (this.post.comments && this.post.comments.data) {
                    for (const comment of this.post.comments.data) {
                        if (comment.id == commentId) {
                            return returnNode ? this.post.comments : comment;
                        } else if (comment.comments && comment.comments.data) {
                            for (const subComment of comment.comments.data) {
                                if (subComment.id == commentId) {
                                    return returnNode ? comment.comments : subComment;
                                }else if (subComment.comments && subComment.comments.data) {
                                    for (const subsubComment of subComment.comments.data) {
                                        if (subsubComment.id == commentId) {
                                            return returnNode ? subComment.comments : subsubComment;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            },
            
            async toggleLikeComment(nodeId) {
                let comment = this.getCommentById(nodeId) 
                console.log("toggleLikeComment",comment)
                const toggleFlagLike = (comment)=>{
                    comment.user_likes = comment.user_likes ? !comment.user_likes : true
                    return comment.user_likes 
                }

                const flagLike = toggleFlagLike(comment)
                if (flagLike !== undefined) {
                    let res = await this.likeNode(this.page, nodeId)
       
                    const { success, error } = res.body
                    console.log(comment)
                    if (!success || success !== true) {
                        toggleFlagLike(comment)
                        return false
                    }

                    return true
                    
                }
            },
    
            async sendComment(formData,filesUrl = []) {


                if (this.event && formData.get('message')) {
             
                    // if (!commentTarget.comments || !commentTarget.comments.data) {
                    //     console.log("!commentTarget.comments || !commentTarget.comments.data")
                    //     commentTarget.comments = {
                    //         data : [

                    //         ],
                    //         summary : {
                    //             "order":"ranked",
                    //             "total_count":0,
                    //             "can_comment":true
                    //         }
                    //     }
                    // }
                
                    // commentTarget.comments.data = [...commentTarget.comments.data, {
                    //     can_hide: false,
                    //     comment_count: 0,
                    //     created_time: new Date().toISOString(),
                    //     from: {"name":this.page.name, email:"", id: this.page.network_id},
                    //     id: "",
                    //     is_hidden: false,
                    //     like_count: 0,
                    //     message: formData.get('message'),
                    //     user_likes: false,
                    // }]
                    
                    let res = await this.addComment(this.page, this.event.data.changes.value.open_graph_story_id , formData.get('message'))
                    const { success, comment } = res.body

                    if (!success || success !== true) {
                        //commentTarget.comments.data.pop()
                        return
                    }
                             
                    this.stopResponseComment()
                }

            },

            async clickOptionComment(id, nameOption) {
                console.log("clickOptionComment ",nameOption)
            
                switch (nameOption) {
                    case 'deleteComment': {
                        //save parent
                        let nodeComment = this.getCommentById(id,true)
                    
                        if (nodeComment) {
                            let saveNodeComment = Object.assign({}, nodeComment);
                            nodeComment.data = nodeComment.data.filter((comment) => comment.id !== id)
                            
                            let res = await this.deleteNode(this.page, id)
                            let { success, error } = res.body;
                            console.log(success, error)
                            if (!success || success !== true) {
                                nodeComment = saveNodeComment
                            }
                        }

                        break;
                
                    }
                        
                    case 'hideComment': {
                        let commentHide = this.getCommentById(id)
                        commentHide.is_hidden = false
                        let resHideComment = await this.hideNode(this.page, this.event.object_id, true)  //true, incoherence du server (ça devrait etre true) 
                        let { success: hideSuccess, error: hideError } = resHideComment.body;
                        console.log("resHIDEComment ",hideSuccess)
                        if (!hideSuccess || hideSuccess !== true) {
                            commentHide.is_hidden = false
                        }
                        break;
                    }

                    case 'showComment':{
                        let commentShow = this.getCommentById(id)
                        commentShow.is_hidden = true
                        console.log("resShowComment")
                        let resShowComment = await this.hideNode(this.page, this.event.object_id, false) //false, incoherence du server (ça devrait etre false) 
                        let { success: showSuccess, error: showError } = resShowComment.body;
                        console.log("resShowComment ",showSuccess)
                        if (!showSuccess || showSuccess !== true) {
                            commentShow.is_hidden = false
                        }
                        break;
                    }

                    
              
                }
            },
     
            getOptionComment(idComment, comment) {
                if (!comment) {
                    comment = this.getCommentById(idComment)
                }

                let options = [{label: this.$t('dash.button.delete'), name : 'deleteComment'}]
                //,{label: this.$t('dash.inbox.filter.evaluate'), name : 'evaluateComment'}

                if (comment.can_hide && comment.from.id !== this.page.network_id) {

                    if (comment.is_hidden) {
                        options = [{label: this.$t('dash.inbox.state.unhide'), name : 'showComment'},...options]
                    }else{
                        options = [{label: this.$t('dash.pages.group.hide'), name : 'hideComment'},...options]
                    }
      
                }
                return options



            },

            // async getDetailAllComment() {
            //     if (this.event) {
              
            //         let res = await this.getCommentPost(this.page, this.post.id, oldComment.id)
            //         const { success, error, comment } = res.body
            //         console.log(success,comment)
            //         if (!success || success !== true || !comment) {
            //             return oldComment
            //         }
            //         return comment
                    
            //     }
            // }

            
        },

        watch: {
            post() {
                //this.getDetailAllComment()
            }
        },
    }
</script>
